// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3922": "57d5af93","8696": "bbb68422","9672": "9c7d2384",}[chunkId] + ".css"
}